import * as React from "react"
const DuctIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#9CA3AF"
      d="M19.036 4H9.13a.364.364 0 0 0-.178.047.481.481 0 0 0-.15.136L.136 15.8a.665.665 0 0 0-.1.201.807.807 0 0 0-.036.238v6.639c0 .343.208.622.464.622h9.905a.364.364 0 0 0 .178-.047.482.482 0 0 0 .15-.136L19.364 11.7a.665.665 0 0 0 .1-.201.806.806 0 0 0 .036-.238V4.622a.743.743 0 0 0-.136-.44.415.415 0 0 0-.328-.182Zm-.465 7.003-7.738 10.373v-4.88l7.738-10.372v4.88ZM9.323 5.245h8.592l-7.738 10.372H1.585L9.323 5.245ZM.929 16.862h3.367L.93 21.376v-4.514Zm4.68 0h4.296v5.393h-8.32l4.024-5.393Z"
    />
  </svg>
)
export default DuctIcon